import { getApiUrl } from '@/lib/api';

const BACKUP_KEY = 'impersonation_backup';
const LOCAL_KEYS = ['token', 'admin', 'tenant', 'schemaName', 'userMode', 'isTenantUser', 'org'] as const;

export interface ImpersonationState {
  email: string;
  expiresAt: string;
}

export function getImpersonation(): ImpersonationState | null {
  try {
    const raw = sessionStorage.getItem(BACKUP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.impersonating ?? null;
  } catch {
    return null;
  }
}

/** Swap the current superadmin session for the impersonated one, keeping the original to restore later. */
export function startImpersonation(result: { token: string; expiresAt: string; admin: { email: string } & Record<string, unknown> }) {
  const backup: Record<string, string | null> = {};
  for (const key of LOCAL_KEYS) backup[key] = localStorage.getItem(key);
  sessionStorage.setItem(BACKUP_KEY, JSON.stringify({ backup, impersonating: { email: result.admin.email, expiresAt: result.expiresAt } }));
  for (const key of LOCAL_KEYS) localStorage.removeItem(key);
  localStorage.setItem('token', result.token);
  localStorage.setItem('admin', JSON.stringify(result.admin));
  window.location.assign('/tenants');
}

/** Drop the impersonated session and restore the superadmin's own. */
export async function stopImpersonation() {
  let stored: { backup: Record<string, string | null> } | null = null;
  try {
    stored = JSON.parse(sessionStorage.getItem(BACKUP_KEY) || 'null');
  } catch {
    stored = null;
  }
  const impersonatedToken = localStorage.getItem('token');
  if (impersonatedToken) {
    try {
      await fetch(`${getApiUrl()}/auth/logout`, { method: 'POST', headers: { Authorization: `Bearer ${impersonatedToken}` } });
    } catch {
      // the session expires on its own within the hour
    }
  }
  for (const key of LOCAL_KEYS) localStorage.removeItem(key);
  if (stored) {
    for (const key of LOCAL_KEYS) {
      const value = stored.backup[key];
      if (value !== null && value !== undefined) localStorage.setItem(key, value);
    }
  }
  sessionStorage.removeItem(BACKUP_KEY);
  window.location.assign('/superadmin/users');
}
